import { useEffect } from 'react';

import { withCookies } from 'react-cookie';

import { initAffiliateData } from './index';

import type { AffiliateData } from './index';
import type { Cookies } from 'react-cookie';

interface AffiliateTrackerProps {
    cookies: Cookies;
    onInit: (affiliateData: AffiliateData) => void;
}

const AffiliateTracker = ({ cookies, onInit }: AffiliateTrackerProps) => {
    useEffect(() => {
        const affiliateData = initAffiliateData(cookies);
        onInit(affiliateData);
    }, []);
    return null;
};

export { AffiliateTracker };
// NB: we need withCookies HOC to get the cookies class object. useCookies hook provides a different API
export default withCookies(AffiliateTracker);
